import styled from 'styled-components';

import { HOME, MOBILE, SPACE } from '../../../../theme/tokens';

/** The report button, at the overview card's top right: the header pills' outline, with its label beside the glyph
 *  where there is room, a round icon-only button on a phone. */
export const Pill = styled.button`
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: ${SPACE[8]};
  height: 40px;
  padding: ${SPACE[0]} ${SPACE[16]} ${SPACE[0]} ${SPACE[12]};
  color: ${HOME.t50};
  border: 2px solid ${HOME.intervalBorder};
  background: transparent;
  border-radius: 100px;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  ${MOBILE} {
    width: 40px;
    padding: ${SPACE[0]};
    justify-content: center;
  }
`;

/** The label, dropped on a phone (the glyph and the button's name still say what it does). */
export const Label = styled.span`
  ${MOBILE} {
    display: none;
  }
`;
